<div class="container-fluid">
  @let localHome = home();
  @if (localHome) {
    <footer class="row section pb-0">
      <div class="col-12 col-lg-6 text-center text-lg-start mb-4 mb-lg-0 padding-footer">
        <h3 class="white mb-2">
          {{ localHome.home.language.footer_title_one }}
        </h3>
        <div class="mb-0 footer-content" [innerHTML]="footerAbout()"></div>
      </div>

      <div
        class="col-12 col-sm-6 col-lg-3 d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start mb-4 mb-lg-0"
      >
        <h3 class="white mb-2">{{ localHome.home.language.footer_title_two }}</h3>
        <div class="d-flex gap-2 mb-1">
          <img src="img/icons/cursor_clic.svg" height="18" />
          <a target="_blank" [href]="localHome.home.language.how_work">
            {{ 'como_funciona' | translate }}
          </a>
        </div>
        <div class="d-flex gap-2 mb-1">
          <img src="img/icons/creditos_icon.svg" height="20" />
          <a target="_blank" [href]="localHome.home.language.credits">
            {{ 'credito_de_contenido' | translate }}
          </a>
        </div>
        <div class="d-flex gap-2 mb-1">
          <img src="img/icons/terms.svg" height="20" />
          <a target="_blank" routerLink="/pages/privacy-policies/terms-condition">
            {{ 'terms-condition' | translate }}
          </a>
        </div>
      </div>

      <div
        class="col-12 col-sm-6 col-lg-3 d-flex flex-column align-items-center align-items-lg-start text-center text-lg-start mb-4 mb-lg-0"
      >
        <h3 class="white mb-2">{{ localHome.home.language.footer_title_two }}</h3>
        <div class="d-flex align-items-center gap-2 mb-1">
          @for (social of socialLinks(); track social.social_networks) {
            <a [href]="social.url" target="_blank" class="d-flex align-items-center">
              <img [src]="social.icon" alt="icon-social" height="30" />
            </a>
          }
        </div>
        <a class="d-block" target="_blank" [href]="localHome.home.language.how_work">
          {{ 'danos_tu_opinion' | translate }}
        </a>
        <br />
        <p class="mb-0">
          {{ localHome.home.language.footer_title_three }}
        </p>
        <a target="_blank" href="www.cundinamarca.gov.co"> www.cundinamarca.gov.co </a>
      </div>

      <div
        class="col-12 text-center d-flex flex-wrap align-items-center justify-content-center mt-4 p-0"
      >
        <div class="content-partner d-flex justify-content-center gap-3 gap-sm-5">
          @for (partner of sortedLogos; track partner.image) {
            <div class="p-0">
              <a [href]="partner.url" target="_blank">
                <img
                  class="image-sponsors"
                  [lazyLoad]="partner.image | cdnUrl: 300 : true"
                  alt="partner"
                />
              </a>
            </div>
          }
        </div>
      </div>
    </footer>
  }
</div>
